import { render, staticRenderFns } from "./BenchmarksDialog.vue?vue&type=template&id=5a06f76a&"
import script from "./BenchmarksDialog.vue?vue&type=script&lang=ts&"
export * from "./BenchmarksDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BenchmarksDialog.vue?vue&type=style&index=0&id=5a06f76a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports